// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__33lXW","menu":"Sidebar_menu__NCexU","isActive":"Sidebar_isActive__3GfTJ","menuItem":"Sidebar_menuItem__2A1A0"};